import { translate } from '@cashfree-intl/coherent';
import * as Yup from 'yup';

const message = {
  required: `${translate('this_is_a_required_field')}`,
};

export const changeAccountValidationSchema = Yup.object({
  accountNumber: Yup.string()
    .when('locked', {
      is: (locked: { [key: string]: boolean }) => !locked.accountNumber,
      then: schema =>
        schema.matches(
          /^[0-9]{8,23}$/,
          `${translate('enter_valid_account_number')}`,
        ),
    })
    .required(message.required)
    .trim(),
  ifscCode: Yup.string()
    .when('locked', {
      is: (locked: { [key: string]: boolean }) => !locked.ifscCode,
      then: schema =>
        schema.matches(
          /^[0-9a-zA-Z]{11}$/,
          `${translate('invalid_ifsc_code')}`,
        ),
    })
    .required(message.required)
    .trim(),
});
